/**
 * Accordion component type definitions
 */

export enum AccordionSize {
  Compact = 'compact',
  Default = 'default',
}

export enum AccordionVariant {
  Default = 'default',
  Bordered = 'bordered',
}
